/**
 * Which staff roles carry owner-level authority in the console. `IT_ADMIN` is a DukaaNo developer
 * working inside a shop (D-107) and is authorized exactly like `OWNER`, so every owner-only gate
 * asks this one question — mirroring `SecurityConfig.OWNER_LEVEL` on the backend, which is the
 * actual trust boundary. Keep the two in step.
 */
export function isOwnerLevel(role?: string | null): boolean {
  return role === 'OWNER' || role === 'IT_ADMIN'
}
